/* global document, window */

/**
 * Bootstrap popover and modal behaviors.
 */
import map from 'lodash/fp/map';

const bootstrap = ($) => {
  // Move modals to the end of the body to avoid z-index issues.
  const bsModals = document.querySelectorAll('.modal');
  map(modal => document.body.appendChild(modal), bsModals);

  // Focus the first element of a modal, or the modal itself if there isn't an
  // available input.
  $(document).on('shown.bs.modal', (evt) => {
    const firstInput = evt.target.querySelector('a, input, button:not(.close)');
    if (firstInput) {
      setTimeout(() => $(firstInput).focus(), 100);
    } else {
      setTimeout(() => $(evt.target).focus(), 100);
    }
  });

  // Popovers
  map((popover) => {
    const $content = $(popover).next('div');
    // Open links within popovers in a new (small) window. Used for social
    // media sharing links.
    /* eslint-disable-next-line */
    $('a[href^="http"]', $content).on('click touch', function (evt) {
      evt.preventDefault();
      window.open(
        this.href,
        'targetWindow',
        'toolbar=no, location=no, status=no, menubar=no, scrollbars=yes, resizable=yes, width=800, height=600',
      );
    });
    $('.social-popover').popover({
      content: $content,
      html: true,
      placement: 'bottom',
      trigger: 'hover',
      container: popover,
    }); // .on('shown.bs.popover', () => console.log(popover));
  }, document.querySelectorAll('.social-popover'));
};

export default bootstrap;
